<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Cover: The Future King, by James Riley" aria-describedby="cover-alt" class="imagefp" role="doc-cover" src="e9781534425774/images/9781534425774.jpg"/></div>
<aside hidden="hidden" id="cover-alt">
<p>Revenge of Magic</p>
<p>The Future King</p>
<p>James Riley</p>
<p><i>New York Times</i> Bestselling author of Story Thieves</p>
</aside>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?42add036